import React from 'react';
const painPoints = ['El martes a las 22:00 seguís buscando en Google "actividades para bebés de 8 meses" sin saber si lo que encontrás es confiable o si realmente sirve para tu hijo.', 'Tu hijo tiene meses y no sabés si lo que hace es normal, si está retrasado o si ya perdiste tiempo valioso que no va a volver.', 'Querés estimularlo pero no sabés por dónde empezar, cuánto tiempo dedicarle ni si lo que hacés tiene algún impacto real en su desarrollo.', 'Ves a otros bebés de la misma edad hacer cosas que el tuyo todavía no hace y no sabés si preocuparte, esperar o actuar.', 'Sentís que el tiempo pasa demasiado rápido, que cada semana que improvisás es una semana que no vuelve y que tu hijo se merece más.'];
export function PainPoints() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(252,248,255) 0%, rgb(243,232,255) 15%, rgb(243,232,255) 85%, rgb(253,244,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-186">
      <div className="mx-auto max-w-4xl" data-id="element-187">

        {/* ── SECTION TITLE ── */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-188">
          ¿Te sentís identificada?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-189">
          Esto le pasa al 90% de las madres
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-190">
          No es falta de amor. Es falta de un sistema.
        </p>

        {/* ── PAIN POINTS GRID ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-191">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white/80 border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-192">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-193">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-194">{point}</p>
            </div>)}
        </div>

        {/* ── BOTTOM CTA ── */}
        <p className="text-center text-xl sm:text-2xl font-black m-0 mb-6" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-195">
          ¿Cuántas semanas más vas a improvisar el desarrollo de tu hijo?
        </p>

        {/* ── DIVIDER ── */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(168,85,247), rgba(255,255,255,0))'
      }} data-id="element-196" />
      </div>
    </section>;
}